import React, { Component } from 'react'
import { List, Toast } from 'antd-mobile'
import './index.less'
import StoreInfo from './components/store-info'
import GoodsTitle from './components/goods-title'
import GoodsItem from './components/goods-item'
import TextInfo from './components/text-info/index'
import OrderTotalPrice from './components/order-total'
import OrderButton from './components/order-button'
import CourierInfo from './components/courier-info'
import PayBar from './components/pay-bar'
import { fetchOrderDetail } from '@/api/order-detail'
import CellTitle from './components/cell-title/index'
import CellHeader from './components/cell-header/index'
import RemarkCell from './components/remakr-cell/index'
// import { history } from '../../stores/index'
import { withRouter } from 'react-router'
import { fetchCancelOrder } from '@/api/cancel-order'
import { fetchCancelRefund } from '../../api/cancel-refund'
import { getAuth } from '@/util/storage'
import { setHeader } from '@/util/set-header'

enum JumpType {
  // 取消订单
  cancel = 'cancel',
  // 取消退款
  order_refund_cancel = 'order_refund_cancel',
  // 查看取货码
  lookcode = 'lookcode',
  // 退货申请
  customer_service = 'customer_service',
}

// 支付方式
enum PayWay {
  alipay = 'alipay',
  wxpay = 'wechat',
}

function _getPayType(x: string) {
  if (x === PayWay.alipay) {
    return '支付宝'
  } else if (x === PayWay.wxpay) {
    return '微信'
  } else {
    return ''
  }
}
@(withRouter as any)
export default class OrderDetail extends Component<any, any> {
  state: any = {
    baseModel: {},
    height: 45
  }
  

  UNSAFE_componentWillMount() {
    setHeader({ title: '订单详情' })
  }

  async componentDidMount() {
    let { match } = this.props
    const order_sn = match.params.order_sn
    let auth = getAuth()
    const params = {
      order_sn: order_sn, //申请退货 O201907021310396249 取消退款 O201907021046365741
      auth: auth,
    }
    let data = await fetchOrderDetail(params)
    this.setState({ baseModel: data.data })
    const { baseModel } = this.state
    if (baseModel.code === 'SUCCESS' && baseModel.data.pay) {
      let pay = baseModel.data.pay
      if ((pay.text as string).length > 0) {
        const height  = 50+45
        this.setState({height})
      }
    }
  }

  // 订单商品列表
  _renderGoodsItems() {
    const { baseModel } = this.state
    if (baseModel.code === 'SUCCESS' && baseModel.data.goods_list) {
      let items = baseModel.data.goods_list as Array<any>
      return items.map((item, key) => {
        return (
          <GoodsItem
            key={item.id}
            img={item.cover}
            title={item.title}
            price={item.original_price}
            vipPrice={item.current_price}
            count={item.num}
          />
        )
      })
    }
    return null
  }

  // 门店信息
  _storeInfoItem() {
    const { baseModel } = this.state
    if (baseModel.code === 'SUCCESS') {
      if (baseModel.data.depot) {
        const depot = baseModel.data.depot
        return (
          <StoreInfo
            store={depot.name}
            tel={depot.contact_way}
            address={depot.address}
          />
        )
      } else if (baseModel.data.customer) {
        const customer = baseModel.data.customer
        return (
          <StoreInfo
            store={customer.name}
            tel={customer.contact_way}
            address={customer.address}
          />
        )
      }
    }
    return null
  }

  // 快递员信息
  _courierItem() {
    const { baseModel } = this.state
    if (baseModel.code === 'SUCCESS' && baseModel.data.courier) {
      const courier = baseModel.data.courier
      return (
        <List>
          <CellHeader className="cell-header" />
          <CourierInfo name={courier.name} />
        </List>
      )
    }
    return null
  }

  // 订单信息
  _orderInfo() {
    let ordersn = ''
    let time = ''
    let status = ''
    let payway = ''
    let remark = ''
    const { baseModel } = this.state
    if (baseModel.code === 'SUCCESS') {
      ordersn = baseModel.data.order_sn
      time = baseModel.data.create_time
      status = baseModel.data.state_text
      payway = _getPayType(baseModel.data.pay_way)
      remark = baseModel.data.remark
    }

    return (
      <List>
        <CellHeader className="cell-header" />
        <CellTitle className="cell-title" title="订单信息" />
        <TextInfo title="订单号" brief={ordersn} />
        <TextInfo title="下单时间" brief={time} />
        <TextInfo title="订单状态" brief={status} />
        {payway.length > 0 && <TextInfo title="支付方式" brief={payway} />}
        {remark.length > 0 && <RemarkCell remark={remark} />}
      </List>
    )
  }

  // 结算信息 价格优惠减免
  _orderPrice() {
    const { baseModel } = this.state
    let price = ''
    let intergral = ''
    let coupon = ''
    let total = ''
    let transportFee = ''
    if (baseModel.code === 'SUCCESS') {
      price = baseModel.data.total_price
      intergral = baseModel.data.integral_money
      coupon = baseModel.data.coupon_price
      total = baseModel.data.pay_fee
      transportFee = baseModel.data.transport_fee
    }
    return (
      <List>
        <CellHeader className="cell-header" />
        <CellTitle className="cell-title" title="结算信息" />
        <OrderTotalPrice
          price={price}
          integral={intergral}
          coupon={coupon}
          total={total}
          transportFee={transportFee}
        />
      </List>
    )
  }

  // 操作按钮
  _orderButtons() {
    const { baseModel } = this.state
    if (baseModel.code === 'SUCCESS') {
      let items = baseModel.data.buttons as Array<any>
      let buttons = items.map((item, key) => {
        return (
          <OrderButton
            key={key}
            title={item.text}
            type={item.type}
            onClick={() => this._buttonClick(item.jump)}
          />
        )
      })
      if (buttons.length > 0) {
        return (
          <List>
            <CellHeader className="cell-header" />
            {buttons}
          </List>
        )
      }
    }
    return null
  }

  // 按钮点击事件
  async _buttonClick(jump: any) {
    let jumpType: JumpType = jump.jump_type
    switch (jumpType) {
      case JumpType.cancel:
        this._cancelOrder(jump.jump_value)
        break
      case JumpType.order_refund_cancel:
        this._cancelRefund(jump.jump_value)
        break
      case JumpType.lookcode:
        this.props.history.push({
          pathname: '/lookcode',
          state: { order_sn: jump.jump_value },
        })
        break
      case JumpType.customer_service:
        if (window.WebViewBridge?.eventLabel) {
          window.WebViewBridge?.eventLabel('click_Orderdetails_customerservices', '')
        } else if (window.webkit) {
          window.webkit.messageHandlers.eventLabel.postMessage({'id': 'click_Orderdetails_customerservices'})
        }
        this.props.history.push({
          pathname: '/orderRefund',
          state: { order_sn: jump.jump_value },
        })
        break
    }
  }

  // 取消订单
  async _cancelOrder(order_sn: string) {
    let auth = getAuth()
    let params = {
      order_sn: order_sn,
      auth: auth,
    }
    let res: any = await fetchCancelOrder(params)
    let baseModel = res.data

    if (baseModel.code === 'SUCCESS') {
      if (window.WebViewBridge?.eventLabel) {
        window.WebViewBridge?.eventLabel('click_Orderdetails_cancelorder', '')
      } else if (window.webkit) {
        window.webkit.messageHandlers.eventLabel.postMessage({'id': 'click_Orderdetails_cancelorder'})
      }
      Toast.info('取消订单成功', 1)
      window.location.reload()
    } else {
      Toast.info('取消订单失败', 1)
    }
  }

  // 取消退款
  async _cancelRefund(order_sn: string) {
    let dic = { order_sn: order_sn }
    let res: any = await fetchCancelRefund(dic)
    let baseModel = res.data
    if (baseModel.code === 'SUCCESS') {
      Toast.info('取消退款成功', 1)
      this.props.history.goBack()
    } else {
      Toast.info('取消退款失败', 1)
    }
  }

  _bottomSpace() {
    const { baseModel } = this.state
    if (baseModel.code === 'SUCCESS' && baseModel.data.pay) {
      let pay = baseModel.data.pay
      if ((pay.text as string).length > 0) {
        return <div className="bottom-space" />
      }
    }
    return null
  }

  // toolbar
  _payBar() {
    const { baseModel } = this.state
    if (baseModel.code === 'SUCCESS' && baseModel.data.pay) {
      let pay = baseModel.data.pay
      if ((pay.text as string).length > 0) {
        return (
          <PayBar
            price={baseModel.data.pay_fee}
            onClick={() => this._pay(baseModel.data.order_sn)}
          />
        )
      }
    }
    return null
  }

  _pay(order_sn: string) {
    // history.push({pathname: `/fillorder/pay/${order_sn}`});
    if (window.WebViewBridge?.eventLabel) {
      window.WebViewBridge?.eventLabel('click_Orderlist_pay', "")
    } else if (window.webkit) {
      window.webkit.messageHandlers.eventLabel.postMessage({'id': 'click_Orderlist_pay'})
    }
    this.props.history.push({
      pathname: `/fillorder/pay/${order_sn}/order-list`,
    })
  }

  render() {
    return (
      <div className='order-detail-container' style={{height: `calc(100vh - ${this.state.height}px)`,overflowY:'auto'}}>
        <div className="nav-space" />
        <List className="my-list">
          <CellTitle className="cell-title" title="提货地址" />
          {this._storeInfoItem()}
        </List>
        <List>
          <CellHeader className="cell-header" />
          <GoodsTitle className="" count={1} />
          {this._renderGoodsItems()}
        </List>
        {this._courierItem()}
        {this._orderInfo()}
        {this._orderPrice()}
        {this._orderButtons()}
        {this._bottomSpace()}
        {this._payBar()}
      </div>
    )
  }
}
